export default defineNuxtRouteMiddleware((_to, _from) => {
  const auth = useAuth()
  if (['retainingAccountInfo', 'loggedIn'].includes(auth.accountStatus)) return

  setTimeout(toastRequiredLogin, 500)
  return navigateTo({ path: '/' })
})

function toastRequiredLogin() {
  return useToast({
    severity: 'error',
    detail: '로그인이 필요합니다.',
  })
}
